function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as s } from "./index.es33.js";
import { clsx as k } from "./index.es105.js";
import { Typography as C } from "./index.es35.js";
import { palette as N } from "./index.es36.js";
import { ButtonType as m, ButtonKind as e, ButtonSize as a } from "./index.es139.js";
import { Spinner as S } from "./index.es23.js";
import t from "./index.es140.js";

var o = function o(_ref) {
  var _ref$type = _ref.type,
      p = _ref$type === void 0 ? m.button : _ref$type,
      _ref$kind = _ref.kind,
      l = _ref$kind === void 0 ? e.primary : _ref$kind,
      u = _ref.onClick,
      d = _ref.isDisabled,
      c = _ref.children,
      i = _ref.href,
      y = _ref.download,
      B = _ref.className,
      _ref$size = _ref.size,
      f = _ref$size === void 0 ? a.medium : _ref$size,
      x = _ref.dataTestId,
      r = _ref.isLoading;
  var j = t[l] || t.primary,
      z = t[f] || t.medium,
      n = !!i,
      b = {
    href: i,
    download: y,
    disabled: d,
    className: k(j, z, B)
  };
  return s.jsx(C.Body2, _objectSpread(_objectSpread({
    as: n ? "a" : "button",
    type: n ? void 0 : p,
    onClick: r ? null : u,
    "data-testid": x
  }, b), {}, {
    children: r ? s.jsx(S, {
      size: 16,
      color: N.gray1
    }) : c
  }));
};

o.ButtonKind = e;
o.ButtonSize = a;
o.ButtonType = m;
export { o as Button };